const HeaderCartIcon = (props) => (
  <svg
    width={19}
    height={18}
    viewBox='0 0 19 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.12082 13.825C5.19682 13.825 4.44922 14.5726 4.44922 15.505C4.44922 16.4374 5.18842 17.185 6.12082 17.185C7.04482 17.185 7.80082 16.4374 7.80082 15.505C7.80082 14.5726 7.04482 13.825 6.12082 13.825Z'
      stroke='currentColor'
      strokeWidth={0.63}
      strokeMiterlimit={10}
    />
    <path
      d='M7.04408 9.62501H13.3021C13.9321 9.62501 14.4781 9.28061 14.7721 8.75981L17.7793 3.30821C17.8465 3.19061 17.8885 3.04781 17.8885 2.90501C17.8885 2.43461 17.5105 2.06501 17.0485 2.06501H4.62488L3.82688 0.38501H1.08008V2.06501H2.76008L5.77568 8.43221L4.64168 10.4902C4.50728 10.7338 4.43168 11.011 4.43168 11.305C4.43168 12.229 5.18768 12.985 6.11168 12.985H16.1917V11.305H6.47289C6.35529 11.305 6.26289 11.2126 6.26289 11.095C6.26289 11.0614 6.27129 11.0278 6.28809 10.9942L7.04408 9.62501Z'
      stroke='currentColor'
      strokeWidth={0.63}
      strokeMiterlimit={10}
    />
    <path
      d='M14.5192 13.825C13.5952 13.825 12.8477 14.5726 12.8477 15.505C12.8477 16.4374 13.5952 17.185 14.5192 17.185C15.4516 17.185 16.1992 16.429 16.1992 15.505C16.1992 14.581 15.4516 13.825 14.5192 13.825Z'
      stroke='currentColor'
      strokeWidth={0.63}
      strokeMiterlimit={10}
    />
  </svg>
);
export default HeaderCartIcon;
